import { render, staticRenderFns } from "./record-form.vue?vue&type=template&id=676a48a5&scoped=true&"
import script from "./record-form.vue?vue&type=script&lang=ts&setup=true&"
export * from "./record-form.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./record-form.vue?vue&type=style&index=0&id=676a48a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a48a5",
  null
  
)

/* custom blocks */
import block0 from "./record-form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports